import { Link, useSearchParams } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Divider, Grid, Typography, Stack, useMediaQuery, LinearProgress } from '@mui/material';

// project imports
import AuthWrapper1 from '../AuthWrapper1';
import AuthCardWrapper from '../AuthCardWrapper';
import Logo from 'ui-component/Logo';
import AuthFooter from 'ui-component/cards/AuthFooter';
import { applyActionCode, getAuth } from 'firebase/auth';
import { app } from 'firebaseService/firebase';
import { useEffect, useState } from 'react';

// assets

// ===============================|| AUTH3 - REGISTER ||=============================== //
export const auth = getAuth(app);

const EmailValidateSuccessfully = () => {
  const theme = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
  const [queryParameters] = useSearchParams();
  const email = queryParameters.get('email');
  const actionCode = queryParameters.get('oobCode');
  const [isLoading, setIsLoading] = useState(false);
  const [isValidating, setIsValidating] = useState(false);

  useEffect(() => {
    if (actionCode !== '') {
      setIsLoading(true);
      applyActionCode(auth, actionCode)
        .then(() => {
          setIsValidating(true);
        })
        .catch((error) => {
          console.error('Error: ' + error);
          setIsValidating(false);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, []);

  return (
    <AuthWrapper1>
      <Grid container direction="column" justifyContent="flex-end" sx={{ minHeight: '100vh' }}>
        <Grid item xs={12}>
          <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: 'calc(100vh - 68px)' }}>
            <Grid item sx={{ m: { xs: 1, sm: 3 }, mb: 0 }}>
              <AuthCardWrapper>
                {isLoading && <LinearProgress />}
                <Grid container spacing={2} alignItems="center" justifyContent="center">
                  <Grid item sx={{ mb: 2, mt: 5 }}>
                    <Link to="#">
                      <Logo />
                    </Link>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container direction={matchDownSM ? 'column-reverse' : 'row'} alignItems="center" justifyContent="center">
                      <Grid item>
                        <Stack alignItems="center" justifyContent="center" spacing={1}>
                          <Typography color={theme.palette.secondary.main} gutterBottom variant={matchDownSM ? 'h3' : 'h2'}>
                            {isValidating ? '¡Tu correo fue validado!' : 'El enlace no es valido.'}
                          </Typography>
                          <Typography variant="caption" fontSize="16px" textAlign={matchDownSM ? 'center' : 'center'}>
                            Portal de registros de proyectos para el Gobierno de El Salvador
                          </Typography>
                        </Stack>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} mt={4} mb={5}>
                    {isValidating && (
                      <Stack alignItems="center" justifyContent="center" spacing={1}>
                        <Typography variant="h3">Hola {email}</Typography>
                        <Typography color={theme.palette.primary.main} variant="h4" align="center">
                          Tu correo ha sido validado correctamente, solo queda esperar a que los administradores del portal pre-autoricen tu
                          acceso.
                        </Typography>
                      </Stack>
                    )}
                  </Grid>
                  <Grid item xs={12}>
                    <Divider />
                  </Grid>
                  <Grid item xs={12}>
                    <Grid item container direction="column" alignItems="center" xs={12}>
                      <Typography component={Link} to="/login" variant="subtitle1" sx={{ textDecoration: 'none' }}>
                        ¿Ya tienes una cuenta?
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </AuthCardWrapper>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sx={{ m: 3, mt: 1 }}>
          <AuthFooter />
        </Grid>
      </Grid>
    </AuthWrapper1>
  );
};

export default EmailValidateSuccessfully;
